import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const EnvoyeEmail = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/envoyeMessage`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const AfficheEmail = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheMessage/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


const DeleteEmail = async (idRestaurant) => {
    return await axios.delete(`${BASE_URL}/api/restaurant/deleteMessage/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const ReEnvoyeEmail = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/reEnvoyeMessage`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

export { EnvoyeEmail, AfficheEmail, DeleteEmail, ReEnvoyeEmail }